module.exports = ".utenti-permessi-container{\n\theight: 100%;\n\tpadding-top: 15px;\n\tpadding-bottom: 15px;\n}\n"